"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MovablePrepJobAction = void 0;
exports.MovablePrepJobAction = {
    START: "START",
    RECEIVE: "RECEIVE",
    COMPLETE: "COMPLETE",
    MOVE: "MOVE",
};
//# sourceMappingURL=movable-prep-job-action.js.map